import { Container } from "reactstrap";
import Header from "../../components/globals/Header";
import FilterBasedSearch from "../../components/inputs/FilterBasedSearch";
import UserHomeMap from "../../components/page-sections/UserHomeMap";
import { useUserHomeHooks } from "../../hooks/useUserHomeHooks";
import { useTranslation } from "../../languages";
import { useEffect, useState } from "react";
import { useDeviceLocation } from "../../hooks/utilityHooks";
const Home = ({ onLogout }) => {
  const {
    //all local states
 
    allPlacesData,
    normalEvents,
  
    //all hooks
    user_redux,
  } = useUserHomeHooks();
  const {location}=useDeviceLocation(true);
  const { t } = useTranslation();
  const [mapCenter, setMapCenter] = useState({ lat: 33.6844, lng: 73.0479 }); // Default: Islamabad
  const [filteredPlaces,setFilteredPlaces]=useState([]);

 
useEffect(()=>{
  setFilteredPlaces(allPlacesData)
},[allPlacesData])



  return (
    <div>
      <Container fluid>
        <Header
          title={
            <div className="d-flex align-items-center gap-3">
              <h3 className="color-primary-black-2 m-0 f-7 ">{t("hello")}!</h3>
              <p className="f-5 m-0">{user_redux?.name?.first}</p>
            </div>
          }
          onLogout={onLogout}
          profilePicture={user_redux?.profilePicture}
        />
        <div>
          <FilterBasedSearch 
          allPlacesData={filteredPlaces}
          setAllPlacesData={setFilteredPlaces}
          originalPlacesData={allPlacesData}
          
          />
          <UserHomeMap mapCenter={mapCenter}
          setMapCenter={setMapCenter}
          placesData={filteredPlaces}
          normalEvents={normalEvents}
          userLocation={location}
          />
        </div>
      </Container>
    </div>
  );
};

export default Home;
